import PatientExistsFormContainer from './PatientExistsFormContainer';

export default PatientExistsFormContainer;
